var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('UserNav'),_c('h1',{staticClass:"page-title"},[_vm._v("МОЙ ПРОФИЛЬ")]),_c('div',{staticClass:"cards"},[_c('router-link',{staticClass:"btn middle btn--pay",attrs:{"to":"/shop","tag":"button"}},[_c('svg-home'),_c('span',[_vm._v("НА ГЛАВНУЮ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }